import { render, staticRenderFns } from "./OptimizerCheckbox.vue?vue&type=template&id=4b73ce86&scoped=true&"
import script from "./OptimizerCheckbox.vue?vue&type=script&lang=js&"
export * from "./OptimizerCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73ce86",
  null
  
)

export default component.exports